export function getMeta(name, transformer) {
    var element = document.querySelector("meta[name=\"" + name + "\"]");
    var rawContent = element === null || element === void 0 ? void 0 : element.getAttribute('content');
    if (element === null || rawContent == undefined) {
        return null;
    }
    if (typeof transformer === 'function') {
        return transformer(rawContent);
    }
    return rawContent;
}
